import { useAppDispatch, useAppSelector } from '@store/hooks';
import { useNavigate } from 'react-router-dom';
import { getMeetingInfoInput } from '@store/meeting/meeting.slice';
import { useEffect } from 'react';
import './CheckLawfulFrame.scss';
import { changeIfShowAgreement, changeIfShowMobileVerify } from '@store/ui/ui.slice';
import { getCurrentLanguage } from '@utils/i18n';
import { t } from 'i18next';
import { getVoovAuthInfo } from '@store/authentication/authentication.slice';

const CheckLawfulFrame = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const meetingInputInfo = useAppSelector(getMeetingInfoInput);
  const voovAuthInfo = useAppSelector(getVoovAuthInfo);

  const frameUrl = `${
    window.location.origin
  }/fill-in-region-and-birth.html?platform=web&from_page=guest_join&region=df&scheme=register&lawful_type=guest_join&m_login_source_id=0&lang=${getCurrentLanguage()}&device_id=${
    voovAuthInfo?.deviceId ?? ''
  }`;

  useEffect(() => {
    const callback = (event: any) => {
      if (event.origin === window.location.origin) {
        const schemeStr = event.data.msg || '';
        if (schemeStr) {
          // 入会
          if (meetingInputInfo.meetingCode) {
            navigate(`/${meetingInputInfo.meetingCode}`);
            dispatch(changeIfShowAgreement(false));
            dispatch(changeIfShowMobileVerify(false));
          }
        }
      }
    };
    window.addEventListener('message', callback, false);

    return () => {
      window.removeEventListener('message', callback);
    };
  }, []);

  // const onBack = () => {
  //   dispatch(changeIfShowAgreement(false));
  // };

  return (
    <div className="check-lawful">
      <div className="check-lawful__header">{t('协议')}</div>
      <iframe src={frameUrl} id="iframe" scrolling="auto" width="100%" />
    </div>
  );
};

export default CheckLawfulFrame;
